import { QueryResult, useQuery } from '@eika-infrastruktur/react-query';

import type { Currency, CurrencyExchangeResult } from '../generated-types';
import { getCounterValue } from '../services/currencyService';

const toCurrency: Currency = 'NOK';

const useCounterValue = (
    amount: number,
    selectedCurrency?: Currency,
    successCallback?: (data: CurrencyExchangeResult) => void,
): QueryResult<CurrencyExchangeResult> =>
    useQuery<CurrencyExchangeResult>({
        queryKey: ['counter-value', selectedCurrency, amount],
        queryFn: () => getCounterValue(selectedCurrency!, toCurrency, amount),
        enabled: !!selectedCurrency && !!amount,
        onSuccess: successCallback,
    });

export default useCounterValue;
